<template>
  <div class="contract-list" v-loading="importLoading">
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="合同编号:">
          <el-input v-model="form.codeNumber" size="mini" placeholder="请输入合同编号"></el-input>
        </el-form-item>
        <el-form-item label="合同名称:">
          <el-input v-model="form.contractName" size="mini" placeholder="请输入合同名称"></el-input>
        </el-form-item>
        <el-form-item label="合同类型:">
          <el-select v-model="form.type" filterable size="mini" placeholder="全部">
            <el-option
              v-for="(item, index) in contactTypeList"
              :label="item.typeName"
              :value="item.typeId"
              :key="`${index}a`"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签订单位:">
          <el-input
            v-model="form.companyName"
            size="mini"
            placeholder="请输入合同签订公司"></el-input>
        </el-form-item>
        <el-form-item label="承办人:">
          <el-input v-model="form.addPeopleName" size="mini" placeholder="请输入承办人"></el-input>
        </el-form-item>
        <!-- <el-form-item label="签约人:">
          <el-input v-model="form.signatoryName" size="mini" placeholder="请输入签约人"></el-input>
        </el-form-item> -->
        <!--        <el-form-item label="签记时间:">-->
        <!--          <el-date-picker-->
        <!--            v-model="form.createTimes"-->
        <!--            type="datetimerang"-->
        <!--            size="mini"-->
        <!--            range-separator="至"-->
        <!--            start-placeholder="开始日期"-->
        <!--            end-placeholder="结束日期"-->
        <!--            value-format="yyyy-MM-dd HH-mm-ss"-->
        <!--          >-->
        <!--          </el-date-picker>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="签约日期:">-->
        <!--          <el-date-picker-->
        <!--            v-model="form.signatoryData"-->
        <!--            type="daterang"-->
        <!--            size="mini"-->
        <!--            range-separator="至"-->
        <!--            start-placeholder="开始日期"-->
        <!--            end-placeholder="结束日期"-->
        <!--            value-format="yyyy-MM-dd"-->
        <!--          >-->
        <!--          </el-date-picker>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="有效起开始时间:" label-width="120px">-->
        <!--          <el-date-picker-->
        <!--            v-model="form.validityTime"-->
        <!--            type="daterang"-->
        <!--            size="mini"-->
        <!--            range-separator="至"-->
        <!--            start-placeholder="开始日期"-->
        <!--            end-placeholder="结束日期"-->
        <!--            value-format="yyyy-MM-dd"-->
        <!--          >-->
        <!--          </el-date-picker>-->
        <!--&lt;!&ndash;          placeholder="请选择有效期开始时间"&ndash;&gt;-->
        <!--        </el-form-item>-->
        <el-form-item label="有无合同附件:">
          <el-select v-model="form.isFile" filterable size="mini" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="没有" value="0"></el-option>
            <el-option label="有" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="form.status" filterable size="mini" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="待开始" value="0"></el-option>
            <el-option label="执行中" value="1"></el-option>
            <el-option label="已结束" value="2"></el-option>
            <el-option label="已取消" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">新增</el-button>
          <el-upload
            ref="upload"
            style="display: inline-block; margin-left: 10px;"
            :action="uploadUrlCR"
            :auto-upload="true"
            :show-file-list="false"
            :data="uploadDataCR"
            :on-success="planOnSuccessCR"
            :before-upload="beforeUploadCR">
            <el-button size="small" type="primary">导入合同关系</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div style="display: flex; justify-content: flex-end">
        <!-- <span style="cursor:pointer;font-size: 16px;margin-right: 20px;color: rgba(51, 136, 255, 1);display: flex;align-items: center;" @click="exportData">导出数据</span> -->
        <span
          class="el-icon-download el-icon--right"
          style="
            cursor: pointer;
            font-size: 16px;
            margin-right: 20px;
            color: rgba(51, 136, 255, 1);
            display: flex;
            align-items: center;
          "
          @click="download"
          >模板下载</span
        >
        <span style="cursor: pointer">
          <el-upload
            ref="upload"
            class="upload-demo"
            style="color: rgba(51, 136, 255, 1)"
            :action="uploadUrl1"
            :auto-upload="true"
            :show-file-list="false"
            :data="uploadData1"
            :on-success="planOnSuccess"
            :before-upload="beforeUpload">
            <i class="el-icon-upload el-icon--right">批量导入</i>
          </el-upload>
        </span>
      </div>
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }">
          <el-table-column
            label="序号"
            align="center"
            width="50px"
            type="index"
            :index="
              index => {
                return this.form.rows * (this.form.page - 1) + index + 1;
              }
            ">
          </el-table-column>
          <el-table-column prop="codeNumber" label="合同编号" width="100" align="center" />
          <el-table-column prop="contractName" label="合同名称" min-width="120" align="center" />
          <el-table-column prop="typeName" label="合同类型" align="center" />
          <el-table-column prop="companyType" label="签约单位类型" width="100" align="center">
            <template slot-scope="scope">{{ scope.row.companyType | companyTypeFormat }}</template>
          </el-table-column>
          <el-table-column prop="companyName" label="签订单位" min-width="150" align="center" />
          <!-- <el-table-column prop="companyName" label="签订单位" min-width="150" align="center">
            <template slot-scope="scope">
             <el-badge value="危" class="item">
               <div style="height: 18px;">
                 {{scope.row.companyName}}
               </div>
             </el-badge>
              <div style="height: 18px;">
                {{scope.row.companyName}}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="addPeopleName" label="承办人" align="center"></el-table-column>
          <el-table-column prop="createTime" label="签记时间" align="center" width="150">
            <template slot-scope="scope">
              {{ scope.row.createTime | formatTime }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="SignatoryTime" label="签约日期" align="center"/> -->
          <el-table-column prop="validityStart" label="有效期" align="center" width="150">
            <template slot-scope="scope">
              {{ scope.row.startDate | validityDady }}--{{ scope.row.endDate | validityDady }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.status | status }}
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            align="center"
            :min-width="operationWidth == 0 ? '230px' : `${operationWidth}px`">
            <template slot-scope="scope">
              <div style="align-items: center" ref="operationWidth" class="caozuo">
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row)"
                  >详情
                </el-button>
                <el-button
                  v-if="statusShow(scope.row, '修改')"
                  size="mini"
                  type="primary"
                  @click="changeClick(scope.row)"
                  class="yellow-bg"
                  >修改
                </el-button>
                <!--                <el-button v-if="statusShow(scope.row,'合同完成')" size='mini' type='danger'
                                           @click='completeClick(scope.row)'>合同完成
                                </el-button>-->
                <el-button
                  v-if="statusShow(scope.row, '合同变更')"
                  size="mini"
                  type="danger"
                  @click="bianClick(scope.$index, scope.row)"
                  >合同变更
                </el-button>
                <el-button
                  v-if="statusShow(scope.row, '终止合同')"
                  size="mini"
                  type="danger"
                  @click="stopClick(scope.row)"
                  >终止合同
                </el-button>
                <!-- <el-button v-if="statusShow(scope.row,'取消审核')"   size="small" class="resetBtn" @click="cancelApproval(scope.row)">取消审核</el-button> -->
                <el-button
                  v-if="statusShow(scope.row, '履约保证金')"
                  size="mini"
                  type="danger"
                  @click="bond2Click(scope.row)"
                  >履约保证金
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  v-if="scope.row.status == 2"
                  @click="contractDelete(scope.row.id)"
                  >删除
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  v-if="scope.row.status == 0"
                  @click="enable(scope.row.id)"
                  >启用
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows" />
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="623px" center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
            <p>{{ detailData.status | status }}</p>
          </div>
          <div class="baseInfoContent">
            <el-form :model="detailData" label-position="left">
              <el-form-item label="合同编号:">
                <span>{{ detailData.codeNumber }}</span>
              </el-form-item>
              <el-form-item label="签约单位:">
                <span>{{ detailData.companyName }}</span>
              </el-form-item>
              <el-form-item label="合同名称:">
                <span>{{ detailData.contractName }}</span>
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同类型:">
                    <span>{{ detailData.typeName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="紧急程度:">
                    <span>{{ detailData.urgent | urgentFormat }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- <el-col :span="12">
                  <el-form-item label="年度表总额:">
                    <div class="center-f">{{detailData.totalYearName}}</div>
                  </el-form-item>
                </el-col> -->
                <el-col :span="24">
                  <el-form-item label="有效期:">
                    <div class="center-f">
                      {{ detailData.startDate | validityDady }}--{{
                        detailData.endDate | validityDady
                      }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="主要内容:">
                <div class="center-f">{{ detailData.content }}</div>
              </el-form-item>
            </el-form>
          </div>
          <div
            class="operation"
            v-if="detailData && detailData.attachments && detailData.attachments.length > 0">
            <div class="operationTitle">
              <div class="line" />
              <span>附件信息</span>
            </div>
            <div class="baseInfoContent" style="padding: 0 23px 10px 23px">
              <div style="display: flex; width: 100%" v-if="detailData.powerType !== 0">
                <el-form :model="detailData" label-position="left" style="width: 100%">
                  <!--                  <span
                                      style='font-weight: 700;margin: 10px 10px;cursor: pointer;display: block;width: 150px;text-decoration: underline'>查看附件人</span>-->
                  <el-row
                    :gutter="10"
                    style="width: 100%"
                    v-for="(item, index) in detailData.attachments"
                    :key="`${index}cvg`">
                    <el-col
                      :span="13"
                      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                      {{ item.attachmentName }}
                    </el-col>
                    <el-col :span="7">{{ item.uploadTime }}</el-col>
                    <el-col :span="2">
                      <i
                        class="el-icon-zoom-in pointer"
                        @click="handlePictureCardPreview(item, index)"
                        v-if="
                          item.attachmentName.substring(item.attachmentName.indexOf('.')) ==
                            '.jpeg' ||
                          item.attachmentName.substring(item.attachmentName.indexOf('.')) ==
                            '.png' ||
                          item.attachmentName.substring(item.attachmentName.indexOf('.')) ==
                            '.gif' ||
                          item.attachmentName.substring(item.attachmentName.indexOf('.')) == '.pdf'
                        " />
                    </el-col>
                    <el-col :span="2">
                      <i class="el-icon-download pointer" @click="downloadClick(item.id)" />
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div
                v-else
                style="
                  font-weight: 700;
                  margin: 10px 10px;
                  cursor: pointer;
                  display: block;
                  width: 150px;
                ">
                暂无权限
              </div>
            </div>
          </div>
          <div class="operation" v-if="detailData.margin && detailData.marginType">
            <div class="operationTitle">
              <div class="line" />
              <span>履约保证金</span>
            </div>
            <!--            :icon="activity.icon"-->
            <div class="baseInfoContent">
              <el-form :model="detailData" label-position="left">
                <el-form-item label="履约保证金金额:">
                  {{ detailData.margin }}
                </el-form-item>
                <el-form-item label="缴纳方式:">
                  {{ detailData.marginType }}
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>其他信息</span>
            </div>
            <div class="baseInfoContent">
              <el-form :model="detailData" label-position="left">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="承办人:">
                      <span>{{ detailData.addPeopleName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--                    <el-form-item label="签约人:">-->

                    <!--                      <div class="center-f">{{detailData.signatoryName}}</div>-->
                    <!--                    </el-form-item>-->
                    <el-form-item label="登记时间:">
                      <span>{{ detailData.createTime | formatTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="签约日期:">
                      <div class="center-f">{{ detailData.createTime | formatTime }}</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!--                <el-row>-->
                <!--                  <el-col :span="12">-->
                <!--                    <el-form-item label="快递单号:">-->

                <!--                      <div class="center-f">{{detailData.price}}</div>-->
                <!--                    </el-form-item>-->
                <!--                  </el-col>-->
                <!--                  <el-col :span="12">-->
                <!--                    <el-form-item label="邮寄日期:">-->
                <!--                      <div class="center-f">{{detailData.time}}</div>-->
                <!--                    </el-form-item>-->
                <!--                  </el-col>-->
                <!--                </el-row>-->
                <el-form-item label="办理完结时间:">
                  <div class="center-f">{{ detailData.overTime }}</div>
                </el-form-item>
                <!--                <el-row>-->
                <!--                  <el-col :span="12">-->
                <!--                    <el-form-item label="原件接方人:">-->
                <!--                      <div class="center-f">{{detailData.price}}</div>-->
                <!--                    </el-form-item>-->
                <!--                  </el-col>-->
                <!--                  <el-col :span="12">-->
                <!--                    <el-form-item label="原件交接日期:">-->
                <!--                      <div class="center-f">{{detailData.time}}</div>-->
                <!--                    </el-form-item>-->
                <!--                  </el-col>-->
                <!--                </el-row>-->
              </el-form>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>操作记录</span>
            </div>
            <!--            :icon="activity.icon"-->
            <div class="baseInfoContent">
              <el-table :data="detailData.operateRecordList" border>
                <el-table-column prop="createTime" label="操作时间" align="center" width="160px" />
                <el-table-column prop="operateType" label="操作类型" align="center" />
                <el-table-column prop="operationName" label="操作人" align="center" />
                <el-table-column prop="remark" label="备注" align="center" />
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="合同变更"
      :visible.sync="changShow"
      width="700px"
      center
      @close="dialogClose(1)">
      <div class="chang">
        <div class="baseInfo">
          <div class="baseInfoContent">
            <el-form
              :model="changeData"
              label-width="150px"
              label-position="right"
              :rules="rule2"
              ref="changeRuleForm"
              class="demo-ruleForm">
              <div class="yang">
                <!--                <div-border label='基础信息' prop='plan'>

                                  <el-form-item label='合同编号:' style='margin-top: 15px'>
                                    {{ changeData.number }}
                                  </el-form-item>
                                  <el-form-item label='签订单位:'>
                                    {{ changeData.company }}
                                  </el-form-item>
                                  <el-form-item label='合同名称' prop='name'>
                                    <el-input v-model='changeData.name' size='mini'
                                              placeholder='请选择合同名称'></el-input>
                                  </el-form-item>

                                  &lt;!&ndash;                  <el-form-item label="合同类型:" prop="type">&ndash;&gt;
                                  &lt;!&ndash;                    <el-input v-model="changeData.type" size="mini"></el-input>&ndash;&gt;
                                  &lt;!&ndash;                  </el-form-item>&ndash;&gt;
                                  <el-form-item label='紧急程度' prop='degree'>
                                    <el-radio-group v-model='changeData.degree'>
                                      <el-radio :label='1'>紧急</el-radio>
                                      <el-radio :label='2'>急</el-radio>
                                      <el-radio :label='3'>一般</el-radio>
                                    </el-radio-group>
                                  </el-form-item>

                                  <el-form-item label='年度标总额:' prop='bidPrice'>
                                    <el-select v-model='changeData.bidPrice' filterable placeholder='请选择年度标总额'
                                               size='mini'>
                                      <el-option v-for='item in bidPriceOption' :label='item.classaName'
                                                 :value='item.id' :key='item.id'></el-option>
                                    </el-select>
                                  </el-form-item>
                                  <el-form-item label='开始日期:' prop='startDate'>
                                    <el-date-picker v-model='changeData.startDate' type='date' placeholder='请选择开始日期'
                                                    size='mini' />
                                  </el-form-item>
                                  <el-form-item label='结束日期:' prop='endDate'>
                                    <el-date-picker v-model='changeData.endDate' type='date' placeholder='请选择结束日期'
                                                    size='mini' />
                                  </el-form-item>
                                  <el-form-item label='主要内容:' prop='center' style='margin-top: 20px;'>
                                    <el-input
                                      type='textarea'
                                      :autosize='{ minRows: 2, maxRows: 4}'
                                      placeholder='请输入内容'
                                      v-model='changeData.center' size='mini'>
                                    </el-input>
                                  </el-form-item>
                                  <el-form-item label='变更原因:' prop='reason'
                                                style='margin-top: 20px;margin-bottom: 18px'>
                                    <el-input
                                      type='textarea'
                                      :autosize='{ minRows: 2, maxRows: 4}'
                                      placeholder='请输入内容'
                                      v-model='changeData.reason' size='mini'>
                                    </el-input>
                                  </el-form-item>
                                  <div class='bond'>
                                    <div style='width: 100px' @click='bonddiv =true'>添加履约保证金</div>
                                  </div>
                                </div-border>
                                <div-border label='履约保证金' v-if='bonddiv'>
                                  <i class='el-icon-close icon-close' @click='bonddiv =false'></i>
                                  <el-form-item label='履约保证金额' style='margin-top:15px' prop='bond'>
                                    <el-input v-model='changeData.bond' size='mini'></el-input>
                                  </el-form-item>
                                  <el-form-item label='缴纳方式' prop='mode'>
                                    <el-input v-model='changeData.mode' size='mini'></el-input>
                                  </el-form-item>
                                </div-border>-->
                <div-border label="上传附件">
                  <el-form-item
                    label="查看附件人："
                    prop="img"
                    style="margin-top: 15px"
                    label-width="50px">
                    <!--                    <div>fasdf</div>-->
                    <div class="imgUp">
                      <el-upload
                        ref="upload"
                        class="upload-demo"
                        accept="image/*,.pdf"
                        :action="uploadUrl"
                        :auto-upload="true"
                        :before-upload="beforeAvatarUpload"
                        :show-file-list="false"
                        :data="uploadData"
                        :on-change="uploadChange"
                        :on-success="res => uploadImgFun(res, 2)"
                        :file-list="changeData.img"
                        :limit="1">
                        <!--                    <i class="el-icon-plus"/>-->
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" style="margin-top: 6px; margin-left: 10px">
                          支持扩展名：.pdf .jpg .jpeg .png
                        </div>
                      </el-upload>
                      <div v-for="(item, index) in changeData.img">
                        <div class="upload">
                          <div
                            style="
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              width: 360px;
                            ">
                            {{ item.name }}
                          </div>
                          <div>
                            <i class="el-icon-loading" v-if="item.status !== 'success'"></i>
                            <i
                              class="el-icon-zoom-in"
                              @click="handlePictureCardPreview2(item, index)"
                              v-if="
                                item.name.substring(item.name.indexOf('.')) == '.jpeg' ||
                                item.name.substring(item.name.indexOf('.')) == '.jpg' ||
                                item.name.substring(item.name.indexOf('.')) == '.png' ||
                                item.name.substring(item.name.indexOf('.')) == '.gif' ||
                                item.name.substring(item.name.indexOf('.')) == '.pdf'
                              "></i>
                            <i class="el-icon-upload2" @click="uploadClick(item, index)"></i>
                            <i class="el-icon-delete" @click="handleRemove(item, index)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div-border>
              </div>
              <div class="btnContainer">
                <el-button size="medium" class="searchBtn" @click="chan2Click">确认</el-button>
                <el-button size="medium" class="resetBtn" @click="dialogClose(1)">关闭</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="终止合同"
      :visible.sync="stopShow"
      width="700px"
      center
      @close="dialogClose(2)">
      <div class="chang">
        <div class="baseInfo">
          <div class="baseInfoContent">
            <el-form
              :model="termination"
              label-width="150px"
              label-position="right"
              :rules="rule3"
              ref="stopRuleForm"
              class="demo-ruleForm">
              <div-border label="基础信息" prop="plan">
                <div class="yang">
                  <el-form-item label="合同编号:" style="margin-top: 15px">
                    {{ termination.number }}
                  </el-form-item>
                  <el-form-item label="合同名称">
                    {{ termination.name }}
                  </el-form-item>
                  <el-form-item label="签订单位:">
                    <el-badge value="危" class="item">
                      <div>
                        {{ termination.company }}
                      </div>
                    </el-badge>
                  </el-form-item>
                  <el-form-item label="合同类型:">
                    {{ termination.type }}
                  </el-form-item>
                  <el-form-item label="起止日期:">
                    {{ termination.validity[0] | validityDady }}--{{
                      termination.validity[1] | validityDady
                    }}
                  </el-form-item>
                  <el-form-item label="主要内容:">
                    {{ termination.center }}
                  </el-form-item>
                </div>
              </div-border>
              <div-border label="终止原因" prop="plan">
                <el-form-item prop="reason" style="margin-top: 15px" label-width="60px">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 8, maxRows: 12 }"
                    placeholder="请输入终止原因"
                    v-model="termination.reason"
                    size="mini"
                    style="width: 85%">
                  </el-input>
                </el-form-item>
              </div-border>
              <div class="btnContainer">
                <el-button size="medium" class="searchBtn" @click="Click2">确认</el-button>
                <el-button size="medium" class="resetBtn" @click="dialogClose(2)">关闭</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="添加履约保证金"
      :visible.sync="bondFlag"
      width="700px"
      center
      @close="dialogClose(3)">
      <div class="chang">
        <div class="baseInfo">
          <div class="baseInfoContent">
            <el-form
              :model="bondData"
              label-width="150px"
              label-position="right"
              :rules="rule4"
              ref="bondRuleForm"
              class="demo-ruleForm">
              <div-border label="基础信息" prop="plan">
                <div class="yang">
                  <el-form-item label="合同编号:" style="margin-top: 15px">
                    {{ bondData.number }}
                  </el-form-item>
                  <el-form-item label="合同名称">
                    {{ bondData.name }}
                  </el-form-item>
                  <el-form-item label="履约保证金额" style="margin-top: 15px" prop="bond">
                    <el-input v-model="bondData.bond" size="mini"></el-input>
                  </el-form-item>
                  <el-form-item label="缴纳方式" prop="mode">
                    <el-input v-model="bondData.mode" size="mini"></el-input>
                  </el-form-item>
                </div>
              </div-border>
              <!--              <div-border label="上传附件" prop="plan">-->
              <!--                <el-form-item prop="img" style="margin-top:15px; " label-width="60px">-->
              <!--                  <div class="imgUp">-->
              <!--&lt;!&ndash;                    <div class="imgLength"><span>{{changeData.img.length}}/5</span></div>&ndash;&gt;-->
              <!--                      <el-upload-->
              <!--                        ref="upload2"-->
              <!--                        class="upload-demo"-->
              <!--                        :action="uploadUrl"-->
              <!--                        :auto-upload="true"-->
              <!--                        :before-upload="beforeAvatarUpload"-->
              <!--                        :show-file-list="false"-->
              <!--                        :data="uploadData"-->
              <!--                        :on-change="uploadChange2"-->
              <!--                        :on-success="(res) => uploadImgFun(res, 1)"-->
              <!--                        :file-list="bondData.enclosure"-->
              <!--                        :limit="5"-->
              <!--                      >-->
              <!--                      &lt;!&ndash;                    <i class="el-icon-plus"/>&ndash;&gt;-->
              <!--                      <el-button size="small" type="primary">点击上传</el-button>-->
              <!--                      <div slot="tip" style="margin-top: 6px;margin-left: 10px">支持扩展名：.rar .zip .doc .docx .pdf .jpg...</div>-->
              <!--                    </el-upload>-->

              <!--                    <div v-for="(item,index) in bondData.enclosure">-->
              <!--                      <div class="upload">{{item.name}}-->
              <!--                        <div>-->
              <!--                          <i class="el-icon-loading" v-if="item.status !=='success'"></i>-->
              <!--                          <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item,index)"-->
              <!--                             v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'-->
              <!--                             ||item.name.substring(item.name.indexOf('.')) == '.png'-->
              <!--                             ||item.name.substring(item.name.indexOf('.')) == '.jpg'-->
              <!--                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>-->
              <!--                          <i class="el-icon-upload2" @click="uploadClick2(item,index)"></i>-->
              <!--                          <i class="el-icon-delete" @click="handleRemove2(item,index)"></i></div>-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </el-form-item>-->
              <!--              </div-border>-->
              <div class="btnContainer">
                <el-button size="medium" class="searchBtn" @click="bondClick">确认</el-button>
                <el-button size="medium" class="resetBtn" @click="dialogClose(3)">关闭</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" append-to-body title="图片查看" center>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addflag"
      width="700px"
      center
      @close="dialogClose(4)">
      <add @addclose="addshow" :dilog-number="dilogNumber" ref="contractAdd" :id="modifyId"></add>
    </el-dialog>
    <PDFPreview ref="PDFPreviewRef" />
  </div>
</template>

<script>
  import { baseUrl, baseImgUrl } from '@/config/env';
  import add from './add';
  import { getSessionStore } from '@/config/mUtils';
  import steps from '@/components/steps';
  import divBorder from '@/components/divBorder';
  import { formatTime } from '@/config/mUtils';
  import { getParam } from '@/service/getData';
  import { getImport, getImportUrl } from '@/service/getIP';
  import {
    deleteContract,
    contractPageList,
    contractUpdate,
    contractDetail,
    contractAdd,
    contractAddBond,
    contractUpdateStatus,
    contractTypeSelectList,
    enableContract,
    contractChange,
    contractStop,
  } from '@/service/contract';
  import $ from 'jquery';
  import PDFPreview from '@/components/PDFPreview';

  export default {
    components: {
      add,
      steps,
      divBorder,
      PDFPreview,
    },

    data() {
      return {
        importLoading: false,
        form: {
          contractName: '',
          type: '',
          contractNumber: '',
          companyName: '',
          createTimes: '',
          createEmpName: '', //承办人
          signatoryName: '', //签约人
          signatoryData: '', //签约日期
          validityTime: '', //有效期开始时间
          isFile: '',
          status: '',
          page: 1,
          rows: 10,
        },
        total: 0,
        tableLoad: false,
        TableDatas: [],
        modifyId: '', //修改id
        //详情显示
        detailDialogVisible: false,
        detailData: {},
        operationData: [
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '启用',
            account: '王三文',
            remark: '',
            size: 'large',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '禁用',
            account: '张三丰',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '添加',
            account: '赵兮雪',
            remark: '',
          },
        ],
        //年度总标额
        bidPriceOption: '',
        changeData: {
          number: '',
          company: '',
          name: '',
          degree: '', //紧急程度
          bidPrice: '', //年度标总额
          // validity:'',//有效期
          startDate: '', // 起始日期
          endDate: '', // 结束日期
          center: '', //主要内容
          reason: '', //变更原因
          bond: '', //履约保证金
          mode: '', //缴纳方式
          img: [],
        },
        changShow: false,
        termination: {
          id: '',
          number: '',
          company: '',
          name: '',
          validity: '', //有效期
          center: '', //主要内容
          type: '',
          reason: '',
        },
        dialogTitle: '',
        // 1 为添加 2 修改
        dilogNumber: 1,
        dialogVisible: false,
        dialogImageUrl: '', //图片查看
        uploadUrl: '',
        uploadData: { fileType: '1' },
        uploadUrl1: '', //导入地址
        uploadData1: { mFile: '' },
        uploadDataCR: { file: '' },
        uploadUrlCR: '',
        addflag: false,
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],
        stopShow: false,
        bondData: {
          bond: '', //履约保证金
          mode: '', //缴纳方式
          name: '',
          number: '',
          enclosure: [],
        },
        bondFlag: false,
        bonddiv: false,
        baseImgUrl: baseImgUrl + '/',
        uploadFlag: false, //替换
        uploadIndex: '', //替换索引
        contactTypeList: [],
        bondId: '',
        rule2: {
          name: [
            {
              required: true,
              message: '请选择合同名称',
              trigger: 'blur',
            },
          ],
          degree: {
            required: true,
            message: '请选择紧急程度',
            trigger: 'blur',
          },
          bidPrice: {
            required: true,
            message: '请选择年度标总额',
            trigger: 'blur',
          },
          startDate: {
            required: true,
            message: '请选择起始日期',
            trigger: 'blur',
          },
          endDate: {
            required: true,
            message: '请选择结束日期',
            trigger: 'blur',
          },
          center: {
            required: true,
            message: '请输入合同主要内容',
            trigger: 'blur',
          },
          reason: {
            required: true,
            message: '请输入变更原因',
            trigger: 'blur',
          },
          bond: {
            required: true,
            message: '请输入履约保证金额',
            trigger: 'blur',
          },
          mode: {
            required: true,
            message: '请输入缴纳方式',
            trigger: 'blur',
          },
        },
        rule3: {
          reason: {
            required: true,
            message: '请输入终止原因',
            trigger: 'blur',
          },
        },
        rule4: {
          bond: [
            {
              required: true,
              message: '请输入履约保证金额',
              trigger: 'blur',
            },
            {
              pattern: /^([0-9]+\.?[0-9]*|-[0-9]+\.?[0-9]*)$/,
              message: '请输入数字',
            },
            {
              pattern: /^(\d+|\d+\.\d{1,2})$/,
              message: '最多两位小数',
            },
          ],
          mode: {
            required: true,
            message: '请输入缴纳方式',
            trigger: 'blur',
          },
        },
        operationWidth: 0, //表格操作宽度 动态
        dialogImageUrlList: [],
        basicId: '',
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      statusShow() {
        return function (row, label) {
          let { isMargin, examineStatus, status } = row;
          // status  0:待审核 1：已通过 2：已结束 3：已取消
          // examineStatus 审核状态 0：待审核 1：已通过 2：已拒绝
          //isMargin   //是否填写了履约保证 0：否 1：是

          // status 0:待审核 显示修改、取消审核
          // status 1  examineStatus1
          // 显示 合同完成、合同变更、终止合同
          // status 2
          // 只有详情
          // status 3 只有详情
          // 以status 状态为主，先if判断status，若是等于0，则里面在判断isMargin，并且显示详情、修改、取消审核按钮
          // if判断status等于1，则里面需要添加isMargin判断，然后还添加examineStatus这个判断，若examineStatus 等于1，则显示详情、完成合同、合同变更、终止合同

          switch (label) {
            case '修改':
              return status === 0;
            case '合同完成':
              return status === 1 && examineStatus === 1;
            case '合同变更':
              return status === 1 && examineStatus === 1;
            case '终止合同':
              return status === 1 && examineStatus === 1;
            case '取消审核':
              return status === 0;
            case '履约保证金':
              return isMargin !== 1 && status !== 2 && status !== 3;
          }

          // return true
        };
      },
    },
    filters: {
      formatTime(val) {
        return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
      },
      validityDady(val) {
        return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
      },
      status(val) {
        let text = '';
        switch (val) {
          case 0:
            text = '待开始';
            break;
          case 1:
            text = '执行中';
            break;
          case 2:
            text = '已结束';
            break;
          case 3:
            text = '已取消';
            break;
        }
        return text;
      },
      companyTypeFormat(value) {
        switch (value) {
          case 1:
            return '委托商';
          case 2:
            return '公路供应商';
          case 3:
            return '水路供应商';
          case 4:
            return '港口及其他';
        }
      },
      unitTypeFormat(value) {
        switch (value) {
          case 1:
            return '委托商';
          case 2:
            return '公路供应商';
          case 3:
            return '水路供应商';
          case 4:
            return '港口及其他';
        }
      },
      urgentFormat(val) {
        switch (val) {
          case 1:
            return '紧急';
          case 2:
            return '急';
          case 3:
            return '一般';
        }
      },
    },
    created() {
      this.uploadUrl1 = getImportUrl('/contractAffairs/batchImportContract');
      this.uploadUrlCR = getImportUrl('/contractual/relationship/importRSIExcel');
      this.$nextTick(() => {
        this._contractPageList();
        this.init();
        this._contractTypeSelectList();
      });
    },
    methods: {
      enable(id) {
        this.$confirm('您确认启用该合同么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await enableContract(id);
            if (status !== 0) return this.$message.error(message);
            this.$message.success(message);
            await this._contractPageList();
          })
          .catch(() => {});
      },
      contractDelete(id) {
        this.$confirm('此操作将永久删除合同, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteContract(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._contractPageList();
          })
          .catch(() => {});
      },
      init() {
        this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
      },
      async _contractPageList() {
        this.tableLoad = true;
        let { createTimes, signatoryData, validityTime } = this.form;
        let res = await contractPageList({
          ...this.form,
          start_createTime: createTimes ? createTimes[0] : createTimes,
          end_createTime: createTimes ? createTimes[1] : createTimes,
          start_signatoryTime: signatoryData ? signatoryData[0] : signatoryData,
          end_signatoryTime: signatoryData ? signatoryData[1] : signatoryData,
          validityStart: validityTime ? validityTime[0] : validityTime,
          validityEnd: validityTime ? validityTime[1] : validityTime,
          TypeId: this.form.type,
        });
        this.tableLoad = false;
        if (res.status !== 0) {
          return this.$message.error(res.message);
        }
        this.TableDatas = res.data.records;
        this.total = res.data.total;
        this.tableWidth();
      },
      async _contractDetail(id) {
        let res = await contractDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        return res.data;
      },
      async _getParam() {
        let res = await getParam({ categoryCd: 'contract_total' });
        if (res.status !== 0) return this.$message.error(res.message);
        this.bidPriceOption = res.data;
      },
      async _contractTypeSelectList() {
        let res = await contractTypeSelectList({ contractTypeName: '' });
        if (res.status !== 0) return this.$message.error(res.message);
        this.contactTypeList = res.data.map(item => {
          return {
            typeName: item.contract_name,
            typeId: item.id,
          };
        });
      },
      searchBtn() {
        this.form.page = 1;
        this._contractPageList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;
      },
      addBtn() {
        // 1 为添加 2 修改
        this.dilogNumber = 1;
        this.dialogTitle = '新增合同';
        this.addflag = true;
        //调用子组件 年度总标额
        this.$nextTick(() => {
          this.$refs.contractAdd._getParam();
        });
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._contractPageList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._contractPageList();
      },
      // 详情
      async detailClick(row) {
        this.detailDialogVisible = true;
        this.detailData = await this._contractDetail(row.id);
        this.stepData = this.detailData.contractExamineAffairsList
          ? this.detailData.contractExamineAffairsList.map(item => {
              return {
                title: `${item.authorName} ${item.typeDesc}`,
                time: item.createTime,
                remark: item.remark,
              };
            })
          : this.stepData;
        console.log(this.detailData);
        let array = [];
        if (this.detailData.attachmentList) {
          array = this.detailData.attachmentList.map(item => {
            return {
              name: item.attachmentName,
              url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
              status: 'success',
              id: item.id,
              uploadTime: item.uploadTime,
            };
          });
        }
        this.$set(this.detailData, 'img', array);
        console.log(this.detailData);
      },
      changeClick(row) {
        // 1 为添加 2 修改
        this.dilogNumber = 2;
        this.dialogTitle = '修改合同';
        this.addflag = true;
        this.modifyId = row.id;
        this.$nextTick(() => {
          this.$refs.contractAdd._modifyDetail();
          this.$refs.contractAdd._getParam();
        });
      },
      completeClick(row) {
        this.$confirm('确认合同完成了吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await contractUpdateStatus(row.id, { status: 1 });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._contractPageList();
          })
          .catch(() => {});
      },
      addshow(val) {
        this.addflag = val;
        this._contractPageList();
      },
      chan2Click() {
        this.$refs.changeRuleForm.validate(async (valid, val) => {
          // if(Object.keys(val).length === 1) valid=true;
          if (valid) {
            const submitParams = {
              id: this.basicId,
              attachmentIdStr: '',
            };
            this.changeData.img.forEach((item, index) => {
              if (this.changeData.img.length - 1 === index) {
                submitParams.attachmentIdStr += item.response.data.id;
              } else {
                submitParams.attachmentIdStr += item.response.data.id + ',';
              }
            });
            const { status, message } = await contractChange(submitParams);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.dialogClose(1);
          } else {
            return false;
          }
        });
      },
      dialogClose(flag) {
        switch (flag) {
          case 1:
            this.changShow = false;
            this.$refs.changeRuleForm.resetFields();
            this.searchBtn();
            break;
          case 2:
            this.stopShow = false;
            this.$refs.stopRuleForm.resetFields();
            break;
          case 3:
            this.bondFlag = false;
            this.bondData = {
              bond: '', //履约保证金
              mode: '', //缴纳方式
              name: '',
              number: '',
              enclosure: [],
            };
            this.$refs.bondRuleForm.resetFields();
            break;
          case 4:
            // this.addflag = false
            this.$refs.contractAdd.dialogClose();
            break;
        }
      },
      uploadImgFun(res, index) {
        if (res.status == 0) {
          this.$message.success(res.message);
          if (this.uploadFlag) {
            //如果为替换，得到索引值进行替换
            this.dialogImageUrlList.splice(this.uploadIndex, 1, { id: res.data.id });
            console.log(this.dialogImageUrlList);
            this.uploadFlag = false;
          } else {
            this.dialogImageUrlList.push({ id: res.data.id });
            console.log(this.dialogImageUrlList);
          }
        } else {
          this.$message.error(res.message);
          this.uploadFlag = false;
        }
      },
      handlePictureCardPreview(item, index) {
        console.log(item);
        let token = getSessionStore('token');
        this.dialogImageUrl =
          baseImgUrl +
          '/web/attachmentFtp/download?attachmentId=' +
          (item.id || item.response.data.id) +
          '&access_token=' +
          token;
        if (item.attachmentName.substring(item.attachmentName.indexOf('.')) == '.pdf') {
          this.$nextTick(() => {
            this.$refs.PDFPreviewRef.loadPDF(item.id || item.response.data.id);
          });
          // window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.dialogImageUrl}`, '_blank');
        } else {
          this.dialogVisible = true;
        }
      },
      handlePictureCardPreview2(item, index) {
        console.log(item);
        let token = getSessionStore('token');
        this.dialogImageUrl =
          baseImgUrl +
          '/web/attachmentFtp/download?attachmentId=' +
          (item.id || item.response.data.id) +
          '&access_token=' +
          token;
        if (
          item.response.data.attachmentType === 'pdf' ||
          item.response.data.attachmentType === 'PDF'
        ) {
          this.$nextTick(() => {
            this.$refs.PDFPreviewRef.loadPDF(item.id || item.response.data.id);
          });
          // window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.dialogImageUrl}`, '_blank');
        } else {
          this.dialogVisible = true;
        }
      },
      beforeAvatarUpload(file) {
        // const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
        // const isJPG =TypeArr.includes(file.type)
        const isLt10M = file.size / 1024 / 1024 < 10;
        // if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');

        // return isJPG && isLt10M
        return isLt10M;
      },
      uploadChange(file, fileList) {
        if (this.uploadFlag) {
          this.changeData.img.splice(this.uploadIndex, 1, file);
          this.uploadFlag = false;
        } else {
          this.changeData.img = fileList;
        }
        if (Object.keys(file).includes('response')) {
          if (file.response.status == -1) {
            this.changeData.img.splice(this.changeData.img.indexOf(file), 1);
          }
        }
      },
      uploadChange2(file, fileList) {
        if (this.uploadFlag) {
          this.bondData.enclosure.splice(this.uploadIndex, 1, file);
          this.uploadFlag = false;
        } else {
          this.bondData.enclosure = fileList;
        }
        if (Object.keys(file).includes('response')) {
          if (file.response.status == -1) {
            this.bondData.enclosure.splice(this.bondData.enclosure.indexOf(file), 1);
          }
        }
      },
      //合同变更图片删除
      handleRemove(item, index) {
        this.changeData.img.splice(index, 1);
      },
      //添加履约保证金 图片删除
      handleRemove2(item, index) {
        this.bondData.enclosure.splice(index, 1);
      },
      //外部上传方法，替换   合同变更
      uploadClick(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload.$refs['upload-inner'].handleClick();
      },
      //履约保证金  外部上传方法，替换
      uploadClick2(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload2.$refs['upload-inner'].handleClick();
      },
      // 合同变更显示
      bianClick(index, row) {
        this.basicId = row.id;
        this.changShow = true;
        // this._getParam();
      },
      async bond2Click(row) {
        this.bondFlag = true;
        let { codeNumber, attachmentList, id, contractName } = await this._contractDetail(row.id);
        this.bondData.name = contractName;
        this.bondData.number = codeNumber;
        this.bondId = id;
        let array = attachmentList.map(item => {
          return {
            name: item.attachmentName,
            url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
            status: 'success',
            id: item.id,
            uploadTime: item.uploadTime,
          };
        });
        this.$set(this.bondData, 'enclosure', array);
      },
      //终止合同确认
      Click2() {
        this.$refs.stopRuleForm.validate(async (valid, val) => {
          // if(Object.keys(val).length === 1) valid=true;
          if (valid) {
            let res = await contractUpdateStatus(this.termination.id, {
              status: -1,
              remark: this.termination.reason,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._contractPageList();
            this.$refs.stopRuleForm.resetFields();
            this.stopShow = false;
          } else {
            return false;
          }
        });
      },
      //保证金确认
      bondClick() {
        this.$refs.bondRuleForm.validate(async valid => {
          if (valid) {
            //附件id用逗号隔开
            let fileId = '';
            this.bondData.enclosure.forEach((item, index) => {
              if (this.bondData.enclosure.length - 1 === index) {
                fileId += item.response ? item.response.data.id : item.id;
              } else {
                fileId += item.response ? item.response.data.id + ',' : item.id + ',';
              }
            });
            let { bond, mode } = this.bondData;
            let res = await contractAddBond({
              id: this.bondId,
              margin: bond,
              marginType: mode,
              fileId: fileId,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.bondFlag = false;
            await this._contractPageList();
            this.$refs.bondRuleForm.resetFields();
            this.dialogClose(3);
          } else {
            return false;
          }
        });
      },
      // 终止按钮
      stopClick(row) {
        // this.stopShow = true;
        // let {
        //   id,
        //   contractNumber,
        //   contractName,
        //   companyName,
        //   companyTypeName,
        //   validityEnd,
        //   validityStart,
        //   content,
        // } = row;
        // this.termination = {
        //   id: id,
        //   number: contractNumber,
        //   company: companyName,
        //   name: contractName,
        //   startDate: validityStart,
        //   endDate: validityEnd,
        //   // validity:[validityStart,validityEnd],//有效期
        //   center: content,//主要内容
        //   type: companyTypeName,
        //   reason: '',
        // };
        // this.termination.id = row.id;
        this.$confirm('确认终止合同吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await contractStop(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._contractPageList();
          })
          .catch(() => {});
      },
      cancelApproval(row) {
        this.$confirm('确认要取消审核了吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await contractUpdateStatus(row.id, 2);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._contractPageList();
          })
          .catch(() => {});
      },
      //详情附件下载
      downloadClick(id) {
        let token = getSessionStore('token');
        window.location.href =
          baseUrl + '/web/attachmentFtp/download?attachmentId=' + id + '&access_token=' + token;
      },
      //模板下载
      download() {
        window.location.href = '/file/合同导入模板.xlsx';
      },
      /**
       * 导入成功
       * @param data 分页更新数据
       */
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data;
        // this._contractPageList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._contractPageList();
          },
        });
      },
      planOnSuccessCR(res) {
        this.importLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data;
        // this._contractPageList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._contractPageList();
          },
        });
      },
      beforeUpload(file) {
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData1.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      beforeUploadCR(file) {
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadDataCR.file = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      //导出数据
      exportData() {
        let token = getSessionStore('token');
        let {
          contractName,
          type,
          contractNumber,
          companyName,
          createTimes,
          createEmpName,
          signatoryName,
          signatoryData,
          validityTime,
          status,
        } = this.form;
        // window.location.href = `${baseUrl}/platform/contractAffairs/export?access_token=${token}&contractNumber=${contractNumber}
        //  &companyName=${companyName}&typeId=${type}&createEmpName=${createEmpName}&signatoryName=${signatoryName}&start_createTime=${createTimes[0]}
        //  &end_createTime=${createTimes[1]}&start_signatoryTime=${signatoryData[0]}&end_signatoryTime=${signatoryData[1]}&validityStart=${validityTime[0]}
        //  &validityEnd=${validityTime[1]}&status=${status}&contractName=${contractName}
        //  `
        window.location.href = `${baseUrl}/platform/contractAffairs/export?access_token=${token}&contractNumber=${contractNumber}
       &companyName=${companyName}&typeId=${type}&createEmpName=${createEmpName}&signatoryName=${signatoryName}&start_createTime=${
          createTimes[0] ? createTimes[0] : ''
        }
       &end_createTime=${createTimes[1] ? createTimes[1] : ''}&start_signatoryTime=${
          signatoryData[0] ? signatoryData[0] : ''
        }&end_signatoryTime=${signatoryData[1] ? signatoryData[1] : ''}&validityStart=${
          validityTime[0] ? validityTime[0] : ''
        }
       &validityEnd=${
         validityTime[1] ? validityTime[1] : ''
       }&status=${status}&contractName=${contractName}
       `;
        // console.log(a)
      },
      tableWidth() {
        this.operationWidth = 0;
        this.$nextTick(() => {
          // this.$refs.operationWidth.querySelectorAll('button').forEach(item=>{
          //   console.log(item)
          //   this.operationWidth  +=item.clientWidth +15
          // })
          let divDom = $('.caozuo');
          // 保存按钮最大数
          let max = $(divDom[0]).children().length;
          //保存最大数所在div索引
          let divIndex = 0;
          divDom.each((index, item) => {
            if ($(item).children().length >= max) {
              // 如果大于就重新赋值
              max = $(item).children().length;
              divIndex = index;
            }
          });
          //得到最大button个数 所在div 获取button元素
          $(divDom[divIndex])
            .children()
            .each((index, item) => {
              // console.log($(item).innerWidth())
              this.operationWidth += $(item).innerWidth() + 15;
            });
        });
        // console.log(this.operationWidth)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .contract-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .exportButton {
      text-align: end;

      span {
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
        margin-right: 10px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      .el-form-item {
        margin-bottom: 1px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      .tableContainer {
        margin-bottom: 25px;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-table th > .cell {
            font-weight: 700 !important;
          }
        }
      }
    }

    ::v-deep .detail {
      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 10px 23px 20px 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .el-form-item {
            margin-bottom: 2px;

            .el-form-item__label {
              /*color: #060606;*/
              font-weight: 700;
            }
          }

          .el-timeline-item__wrapper {
            display: flex;
          }

          .el-timeline-item__content {
            flex: 1;
          }

          .el-timeline-item__timestamp.is-bottom {
            flex: 2;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .chang {
      .el-form-item__label {
        font-weight: 700;
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .yang {
            .el-form-item {
              margin-bottom: 15px;

              .el-form-item__label {
                width: 150px !important;
                /*color: #060606;*/
              }

              .el-input {
                width: 372px;
              }

              .el-textarea {
                width: 372px;
              }

              .el-range-editor {
                width: 372px;
              }
            }

            .bond {
              color: #3388ff;
              text-align: end;
              display: flex;
              justify-content: flex-end;
            }

            .bond div:hover {
              color: #335483;
            }

            .icon-close {
              font-size: 21px;
              position: absolute;
              top: 5px;
              right: 9px;
            }

            .icon-close:hover {
              color: #3388ff;
            }
          }

          .imgUp {
            .upload-demo {
              display: flex;
            }

            .upload {
              font-size: 17px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              i {
                margin-right: 10px;
              }

              i:hover {
                color: #00e1ff;
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }
  }

  ::v-deep {
    span.el-icon-download.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    span i.el-icon-upload.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 70vh;
      color: #606266;
    }
  }
</style>
